<div
  class="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-white dark:bg-neutral-950"
>
  <app-floating-paths [position]="1"></app-floating-paths>
  <app-floating-paths [position]="-1"></app-floating-paths>
  <div>
    <div #outerAnimDiv class="max-w-screen-md mx-auto">
      <div
        class="flex justify-center"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 3rem;
        "
      >
        <div #innerAnimDiv>
          <img
            src="assets/images/uplift-logo.png"
            alt="Logo"
            class="max-w-full h-auto"
            style="max-height: 100px"
          />
        </div>
        <div class="button-container">
          <button
            type="button"
            (click)="onStartClick($event)"
            class="my-start-button"
          >
            <span class="label">Démarrer</span>
            <span class="arrow">→</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
